import type { RouteRecordRaw } from 'vue-router'
import type { UserLoginInformationModel } from '@/api/system/model/userLoginInformationModel'

import { DEFAULT_LAYOUT } from '@/router/constant'
import { UserRoleEnum } from '@/enums'

const tradeInfoSuccession: RouteRecordRaw = {
  path: '/trade-info-succession',
  component: DEFAULT_LAYOUT,

  children: [
    {
      path: '',
      name: 'TradeInfoSuccession',

      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/trade-info-succession/TradeInfoSuccession.vue'
        ),

      meta: {
        title: '取引情報の引き継ぎ',
        requiresAuth: true,
        allowUserRole: [UserRoleEnum.RECEIVABLE_USER],
      },

      beforeEnter(to, _, next) {
        const data = sessionStorage.getItem('user_login_information')

        if (!data) {
          next('*')
          return
        }

        const userInfo: UserLoginInformationModel = JSON.parse(data)
        const allowUserList = to.meta.allowUserRole as UserRoleEnum[]
        const userAllowed = allowUserList.includes(userInfo.role_code as UserRoleEnum)

        if (!userAllowed) {
          next('*')
          return
        }

        next()
      },
    },
  ],
}

export default tradeInfoSuccession
